/** @format */

import React, {useState} from 'react';
import ErrorDisplay from 'frontier/utilities/error';
import {ConditionalButton} from 'frontier-utilities';
import GoogleLoginButton from 'frontier/account/components/auth/google_login/google_signin_button';
import ForgotPassword from 'frontier/account/components/forgot_password/container';
import {Input, Button} from '@sttark/design-system';

import './ajax_login.sass';
import useLogin from 'frontier/account/components/auth/ajax_login/use_login';

export default function AccountLoginContainer({redirect}) {
    const {
        username,
        password,
        onInputChange,
        onSubmitLogin,
        onKeyPress,
        isComplete,
        error,
        isAuthorizing
    } = useLogin({redirect});
    const [isPasswordReset, togglePasswordReset] = useState(false);
    return (
        <>
            <div className="row marg-bottom">
                <div className="account-head col-sm-12">
                    <h1>Login</h1>
                    <div>
                        Need an account? (
                        <a
                            className="btn btn-link p-0"
                            href={`?new_account=true&redirect=${window.loginRedirect}`}>
                            Create New Account
                        </a>
                        )
                    </div>
                </div>
            </div>

            <div style={{marginBottom: '50px', width: '500px'}} className="account-ajax-login">
                <div className="account-ajax-login">
                    {isPasswordReset && (
                        <ForgotPassword
                            onClose={togglePasswordReset.bind(this, !isPasswordReset)}
                        />
                    )}
                    {error && (
                        <div className="alert alert-danger">
                            <ErrorDisplay error={error} />
                        </div>
                    )}
                    <div className="form-group_field">
                        <Input
                            label={'*Email'}
                            type="text"
                            name="username"
                            className="form-control"
                            value={username}
                            onChange={onInputChange.bind(this, 'username')}
                            onKeyUp={onKeyPress}
                            placeholder="Enter your Email*"
                        />
                    </div>

                    <div className="form-group_field">
                        <Input
                            label={'*Password'}
                            type="password"
                            name="password"
                            className="form-control"
                            value={password}
                            onChange={onInputChange.bind(this, 'password')}
                            onKeyUp={onKeyPress}
                            placeholder="Password*"
                        />
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <ConditionalButton enabled={isAuthorizing}>
                                <Button
                                    primary
                                    label="Authenticating...."
                                    disabled
                                    onClick={() => {}}
                                    style={{fontSize: '20px'}}></Button>
                                <Button
                                    primary
                                    label="Login"
                                    onClick={onSubmitLogin}
                                    style={{fontSize: '20px'}}></Button>
                            </ConditionalButton>
                            <button
                                className="ajax-login_login-help font-body-bold-lg p-0 ms-4"
                                onClick={togglePasswordReset.bind(this, !isPasswordReset)}>
                                Login Help?
                            </button>
                        </div>
                        <GoogleLoginButton />
                    </div>
                </div>
            </div>
        </>
    );
}
